import './App.css'
import Detail from './Views/detail'
import Home from './Views/Home'
import MyFavorite from './Views/MyFavorite'
import {
  Switch,
  Route,
} from "react-router-dom";
import Navigation from './Components/Navigation'

function App () {
  return (
      <div>
        <Navigation />
        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/detail/:tail">
            <Detail />
          </Route>
          <Route path="/myFavorite">
            <MyFavorite />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </div>
  );
}

export default App